import type { UserProfileType } from '../../types/UserType';
import EditIconButton from './EditIconButton';

type ProfileNicknameProps = Pick<UserProfileType, 'nickname'> & {
  onEditClick?: () => void;
};

const ProfileNickname = ({ nickname, onEditClick }: ProfileNicknameProps) => {
	return (
  <div className="flex items-center gap-[4px]">
    <p className="font-semibold truncate max-w-[125px] w-fit text-main-light-1 dark:text-main-dark-1">
      {nickname ?? '사용자 닉네임'}
    </p>
    <EditIconButton onClick={onEditClick} />
  </div>
);
};

export default ProfileNickname;
